// const API_ENDPOINT = 'http://localhost:3000/';
const API_ENDPOINT = 'https://ist-pdf-export.azurewebsites.net/';

export default API_ENDPOINT;
